import { useEffect, useRef, useState } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

/**
 * Controla microfone / transcrição contínua.
 */
export function useMicControl() {
  const [isListening, setIsListening] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const recordingTimer = useRef(null);

  useEffect(() => {
    if (transcript) {
      setIsTranscribing(true);
    }
  }, [transcript]);

  const toggleListening = (onTranscript) => {
    if (isListening) {
      SpeechRecognition.stopListening();
      clearInterval(recordingTimer.current);
    } else {
      SpeechRecognition.startListening({ continuous: true, interimResults: true, language: 'pt-BR' });
      setRecordingTime(0);
      recordingTimer.current = setInterval(() => setRecordingTime((t) => t + 1), 1000);
    }
    setIsListening(!isListening);
    resetTranscript();
    if (!isListening && onTranscript) {
      // Quando começar a ouvir, limpamos entrada para reescrever
      onTranscript('');
    }
  };

  return {
    isListening,
    isTranscribing,
    recordingTime,
    transcript,
    resetTranscript,
    toggleListening
  };
}
